var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNomuraMountains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none slice",
    width: 160,
    height: 71,
    viewBox: "0 0 160 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6203 0H31.2405L0 70.7808H100.153L103.829 62.7295L107.688 70.7808H132.772L116.049 35.8328L121.47 23.8885L143.247 70.7808H160V0H75.6203Z",
    fill: "#CA2420"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7859 0L99.5103 0.530856L116.049 35.8328L121.471 23.8885L110.353 0H99.7859Z",
    fill: "#CA2420"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0742 70.7806H100.152L103.828 62.7293L87.4724 26.6311L67.0742 70.7806Z",
    fill: "#CA2420"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5279 0.35376L44.0117 70.7806H67.0745L87.4728 26.6311L75.5279 0.35376Z",
    fill: "#AE1A0C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.687 70.7807H132.771L116.049 35.8326L103.828 62.7293L107.687 70.7807Z",
    fill: "#CA2420"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4727 26.6313L103.828 62.7295L116.049 35.8328L99.5094 0.530884L87.4727 26.6313Z",
    fill: "#AE1A0C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4732 26.6313L99.5099 0.530856L99.7856 0H75.6202L75.5283 0.353904L87.4732 26.6313Z",
    fill: "#A31406"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.353 0L121.47 23.8885L132.313 0H110.353Z",
    fill: "#A51509"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNomuraMountains);
export default __webpack_public_path__ + "static/media/nomuraMountains.51b3042c6025b21a820da54a7e353457.svg";
export { ForwardRef as ReactComponent };